import { render, staticRenderFns } from "./TeacherPass.vue?vue&type=template&id=115c8c67&"
import script from "./TeacherPass.vue?vue&type=script&lang=js&"
export * from "./TeacherPass.vue?vue&type=script&lang=js&"
import style0 from "./TeacherPass.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TeacherPass.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports